import AccesRapide from "./AccesRapide";

const HelpAthleteInscription = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Configurer votre inscription', link: '/topics/acces-rapide/rechercher'},
  ];

  const content = <>
    <p className="help-text">
      Vous vous êtes entraîné intensément et êtes prêt à vous inscrire à une compétition ? Vous êtes au bon endroit.
      Tous les raccourcis nécessaires sont disponibles ci-dessous pour vous permettre de le faire en toute simplicité et en toute sérénité.
    </p>
    <p className="mt-48 fw-600 fz-20 mb-12">Trouver votre compétition idéale</p>
    <p className="help-text border-bottom pb-32 mb-0">
      Pour trouver votre compétition idéale, explorez cette<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>liste</a>: 
      elle y figure forcément. 
      Wodzone met à votre disposition un moteur de recherche unique et performant. Grâce à des filtres avancés, trouvez précisément ce dont vous avez besoin.
    </p>
  </>

  return (
    <AccesRapide 
      goBackLinks={goBackLinks} guideInfo='Guide • Athlète' img="/images/inscription.webp" content={content} topicsIds={[26, 27, 35]}
    />
  )
}

export default HelpAthleteInscription